<template>
  <div v-if="isVisible" class="modal-overlay">
    <div class="modal-content">
      <span class="close-btn" @click="closeLogin">&times;</span>

      <section id="login" class="login section-show" style="height: auto!important;">

        <div class="login-form">
          <div class="row mt-2">
            <!-- Информационный блок -->
            <div class="col-lg-7">
              <div class="d-none d-lg-block" style="padding: 100px">
                <img
                    src="/api/image/display?image=zavbusMainLogo2.png"
                    class="img-fluid " alt=""
                >
              </div>
            </div>

            <!-- Блок с полями ввода -->
            <div class="col-lg-5 trip-record">
              <div v-if="loginFormState.errorMessage" class="error-container">
                <i class="fa fa-exclamation-circle"></i> {{ loginFormState.errorMessage }}
                <span class="error-container__close" @click="clearErrorMessage">&times;</span>
              </div>
              <!-- Кнопки переключения вкладок -->
              <div class="btn-group w-100 mb-3" role="group" aria-label="Toggle login/register">
                <button
                    type="button"
                    class="btn"
                    :class="tab === 'login' ? 'btn-primary' : 'btn-outline-primary'"
                    @click="changeTab('login')"
                >
                  Вход
                </button>
                <button
                    type="button"
                    class="btn"
                    :class="tab === 'reg' ? 'btn-primary' : 'btn-outline-primary'"
                    @click="changeTab('reg')"
                >
                  Регистрация
                </button>
              </div>

              <!-- Форма входа -->
              <div v-if="tab === 'login'">
                <div class="form-group">
                  <button
                      type="submit"
                      @click="handleAuthByVk"
                      class="btn btn-light w-100 d-flex align-items-center justify-content-center">
                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" class="me-2">
                      <path
                          d="M0.5 9.6C0.5 5.07452 0.5 2.81177 1.90589 1.40589C3.31177 0 5.57452 0 10.1 0H10.9C15.4255 0 17.6882 0 19.0941 1.40589C20.5 2.81177 20.5 5.07452 20.5 9.6V10.4C20.5 14.9255 20.5 17.1882 19.0941 18.5941C17.6882 20 15.4255 20 10.9 20H10.1C5.57452 20 3.31177 20 1.90589 18.5941C0.5 17.1882 0.5 14.9255 0.5 10.4V9.6Z"
                          fill="#0077FF"></path>
                      <path
                          d="M11.1416 14.4084C6.58331 14.4084 3.98333 11.2834 3.875 6.08337H6.15833C6.23333 9.90004 7.91663 11.5167 9.24996 11.85V6.08337H11.4V9.37503C12.7167 9.23336 14.0999 7.73337 14.5665 6.08337H16.7166C16.3583 8.11671 14.8583 9.61669 13.7916 10.2334C14.8583 10.7334 16.5667 12.0417 17.2167 14.4084H14.8499C14.3416 12.825 13.075 11.6 11.4 11.4334V14.4084H11.1416Z"
                          fill="white"></path>
                    </svg>
                    Войти с VK ID
                  </button>
                </div>
                <hr/>
                <div class="form-group">
                  <input
                      type="text"
                      class="form-control"
                      :class="{ 'input-error': errors.username }"
                      :placeholder="errors.username ? 'Необходимо ввести E-mail' : 'E-mail'"
                      @input="clearFieldError(['username'])"
                      v-model="loginFormState.form.username"
                  />
                </div>
                <div class="form-group">
                  <input
                      type="password"
                      class="form-control"
                      :class="{ 'input-error': errors.password }"
                      :placeholder="errors.password ? 'Необходимо ввести пароль' : 'Пароль'"
                      @input="clearFieldError(['password'])"
                      v-model="loginFormState.form.password"
                  />
                </div>
                <div class="form-group">
                  <button type="submit" class="btn btn-success w-100" @click="handleSignIn">
                    Войти
                  </button>
                </div>
                <a
                    href="#" class="d-block text-center mt-3"
                    @click="changeTab('initpassres')"
                >
                  Забыли пароль?
                </a>
              </div>

              <!-- Форма регистрации -->
              <div v-if="tab === 'reg'">
                <div class="form-group">
                  <button
                      type="submit"
                      @click="handleRegByVk"
                      class="btn btn-light w-100 d-flex align-items-center justify-content-center"
                  >
                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" class="me-2">
                      <path
                          d="M0.5 9.6C0.5 5.07452 0.5 2.81177 1.90589 1.40589C3.31177 0 5.57452 0 10.1 0H10.9C15.4255 0 17.6882 0 19.0941 1.40589C20.5 2.81177 20.5 5.07452 20.5 9.6V10.4C20.5 14.9255 20.5 17.1882 19.0941 18.5941C17.6882 20 15.4255 20 10.9 20H10.1C5.57452 20 3.31177 20 1.90589 18.5941C0.5 17.1882 0.5 14.9255 0.5 10.4V9.6Z"
                          fill="#0077FF"></path>
                      <path
                          d="M11.1416 14.4084C6.58331 14.4084 3.98333 11.2834 3.875 6.08337H6.15833C6.23333 9.90004 7.91663 11.5167 9.24996 11.85V6.08337H11.4V9.37503C12.7167 9.23336 14.0999 7.73337 14.5665 6.08337H16.7166C16.3583 8.11671 14.8583 9.61669 13.7916 10.2334C14.8583 10.7334 16.5667 12.0417 17.2167 14.4084H14.8499C14.3416 12.825 13.075 11.6 11.4 11.4334V14.4084H11.1416Z"
                          fill="white"></path>
                    </svg>
                    Зарегистрироваться с VK ID
                  </button>
                </div>
                <hr/>
                <div class="form-group">
                  <input
                      type="text"
                      class="form-control"
                      :class="{ 'input-error': errors.surname }"
                      :placeholder="errors.surname ? 'Необходимо ввести фамилию' : 'Фамилия'"
                      @input="clearFieldError(['surname'])"
                      v-model="loginFormState.form.surname"
                  />
                </div>
                <div class="form-group">
                  <input
                      type="text"
                      class="form-control"
                      :class="{ 'input-error': errors.name }"
                      :placeholder="errors.name ? 'Необходимо ввести имя' : 'Имя'"
                      @input="clearFieldError(['name'])"
                      v-model="loginFormState.form.name"
                  />
                </div>
                <div class="form-group">
                  <input
                      type="text"
                      class="form-control"
                      :class="{ 'input-error': errors.username || errors.invalidEmail}"
                      :placeholder="errors.username ? 'Необходимо ввести E-mail' : 'E-mail'"
                      @input="clearFieldError(['username', 'invalidEmail'])"
                      v-model="loginFormState.form.username"
                  />
                  <div v-if="errors.invalidEmail" class="form-group__error-message">введите корректный E-mail</div>
                </div>
                <div class="form-group">
                  <input
                      type="password"
                      class="form-control"
                      :class="{ 'input-error': errors.password || errors.differentPasswords  }"
                      :placeholder="errors.password ? 'Необходимо ввести пароль' : 'Пароль'"
                      @input="clearFieldError(['password', 'differentPasswords'])"
                      v-model="loginFormState.form.password"
                  />
                  <span v-if="errors.differentPasswords" class="form-group__error-message">пароли не совпадают</span>
                  <span v-else-if="errors.password" class="form-group__error-message">
                    пароль должен быть не менее 8 символов, содержать хотя бы одну заглавную букву и одну цифру
                  </span>
                </div>
                <div class="form-group">
                  <input
                      type="password"
                      class="form-control"
                      :class="{ 'input-error': errors.confirmPassword || errors.differentPasswords }"
                      :placeholder="errors.confirmPassword ? 'Необходимо повторить пароль' : 'Повторите пароль'"
                      @input="clearFieldError(['confirmPassword', 'differentPasswords'])"
                      v-model="loginFormState.form.confirmPassword"
                  />
                  <span v-if="errors.differentPasswords" class="form-group__error-message">пароли не совпадают</span>
                </div>

                <div class="form-group form-check">
                  <input
                      type="checkbox"
                      class="form-check-input"
                      id="agreeTerms"
                      v-model="loginFormState.form.agreeTerms"
                      :class="{ 'input-error': errors.agreeTerms }"
                  />
                  <label class="form-check-label" for="agreeTerms">
                    Согласен и принимаю
<!--                    <router-link :to="{ name: 'termsOfUse' }" target="_blank" >-->
<!--                      пользовательское соглашение-->
<!--                    </router-link>-->
                    <router-link :to="{ name: 'privacyPolicy' }" target="_blank" >
                      правила использования и обработки персональных данных
                    </router-link>.
                  </label>
                </div>

                <div class="form-group form-check">
                  <input
                      type="checkbox"
                      class="form-check-input"
                      id="agreeGettingAdvert"
                      v-model="loginFormState.form.agreeGettingAdvert"
                      :class="{ 'input-error': errors.agreeGettingAdvert }"
                  />
                  <label class="form-check-label" for="agreeGettingAdvert">
                    Хочу получать
                    <router-link :to="{ name: 'advertisingPolicy' }" target="_blank" >
                      рекламную рассылку
                    </router-link>
                     на указанный email и получить 50 бонусов.
                  </label>
                </div>

                <div class="form-group">
                  <button
                      type="submit"
                      class="btn btn-primary w-100"
                      @click="handleSignUp"
                      :disabled="!loginFormState.form.agreeTerms"
                  >
                    Зарегистрироваться
                  </button>
                </div>
              </div>

              <div v-if="tab === 'initpassres'">
                <div class="form-group">
                  <input
                      type="text"
                      class="form-control"
                      :class="{ 'input-error': errors.username || errors.invalidEmail}"
                      :placeholder="errors.username ? 'Необходимо ввести E-mail' : 'E-mail'"
                      @input="clearFieldError(['username', 'invalidEmail'])"
                      v-model="loginFormState.form.username"
                  />
                  <div v-if="errors.invalidEmail" class="form-group__error-message">введите корректный E-mail</div>
                </div>

                <div class="form-group">
                  <button
                      type="submit"
                      class="btn btn-primary w-100"
                      @click="handleInitResetPassword"
                  >
                    Восстановить
                  </button>
                </div>
              </div>

              <div v-if="tab === 'waitpassres'">
                <h3>
                  Смена пароля
                </h3>
                <p>
                  На указанный вами адрес выслано письмо с дальнейшими инструкциями
                </p>
              </div>

              <div v-if="tab === 'dopassres'">
                <h3>Установите новый пароль</h3>
                <div class="form-group">
                  <input
                      type="password"
                      class="form-control"
                      :class="{ 'input-error': errors.password || errors.differentPasswords  }"
                      :placeholder="errors.password ? 'Необходимо ввести пароль' : 'Пароль'"
                      @input="clearFieldError(['password', 'differentPasswords'])"
                      v-model="loginFormState.newPasswordForm.password"
                  />
                  <span v-if="errors.differentPasswords" class="form-group__error-message">пароли не совпадают</span>
                  <span v-else-if="errors.password" class="form-group__error-message">
                    пароль должен быть не менее 8 символов, содержать хотя бы одну заглавную букву и одну цифру
                  </span>
                </div>
                <div class="form-group">
                  <input
                      type="password"
                      class="form-control"
                      :class="{ 'input-error': errors.confirmPassword || errors.differentPasswords }"
                      :placeholder="errors.confirmPassword ? 'Необходимо повторить пароль' : 'Повторите пароль'"
                      @input="clearFieldError(['confirmPassword', 'differentPasswords'])"
                      v-model="loginFormState.newPasswordForm.confirmPassword"
                  />
                  <span v-if="errors.differentPasswords" class="form-group__error-message">пароли не совпадают</span>
                </div>
                <div class="form-group">
                  <button
                      type="submit"
                      class="btn btn-primary w-100"
                      @click="handleSetNewPassword"
                  >
                    Сохранить новый пароль
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </section>
    </div>
  </div>
</template>

<script lang="ts">
import authStore from "@/store/auth";
import {defineComponent, onMounted, watch} from "vue";
import {LocationQuery, useRoute, useRouter} from 'vue-router';

export default defineComponent({
  name: 'LoginModal',
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    initialTab: {
      type: String,
      required: false,
      default: 'login',
    },
  },
  data() {
    const {
      loginFormState,
      authByVk,
      signIn,
      signUp,
      initResetPassword,
      setNewPassword,
      clearErrorMessage,
      gRecaptchaKey
    } = authStore

    return {
      tab: this.initialTab,
      gRecaptchaKey,
      authByVk,
      signIn,
      signUp,
      initResetPassword,
      setNewPassword,
      loginFormState,
      captchaToken: "",
      clearErrorMessage,
      errors: {
        name: false,
        surname: false,
        username: false,
        password: false,
        confirmPassword: false,
        differentPasswords: false,
        invalidEmail: false,
        agreeTerms: false,
        agreeGettingAdvert: false,
      } as { [key: string]: boolean }
    }
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const {loginFormState, closeLoginModal} = authStore;

    const processQueryParams = (query: LocationQuery) => {
      const token = typeof query.token === "string" ? query.token : null;
      if (token) {
        console.log("processQueryParams", decodeURIComponent(token));
        loginFormState.newPasswordForm.token = decodeURIComponent(token);
      } else {
        loginFormState.newPasswordForm.token = "";
      }

      loginFormState.newPasswordForm.username = typeof query.username === "string"
          ? query.username
          : "";
      loginFormState.newPasswordForm.timestamp = typeof query.timestamp === "string"
          ? parseInt(query.timestamp, 10)
          : -1;
    };

    watch(
        () => route.query, // Наблюдаем за query-параметрами
        (newQuery) => {
          processQueryParams(newQuery);
        },
        {immediate: true} // Вызывается сразу при загрузке
    );

    onMounted(() => {
      processQueryParams(route.query);
    });

    return {router, route, closeLoginModal};
  },
  watch: {
    // Следим за изменением маршрута и обновляем вкладку
    'route.query.tab': {
      immediate: true,
      handler(newTab) {
        this.tab = newTab || 'login'; // Если таб не указан, по умолчанию 'login'
      },
    },
  },
  methods: {
    closeLogin() {
      this.closeLoginModal();
      // Убираем параметры из URL при закрытии
      const {slm, tab, hash, token, timestamp, username, ...restQuery} = this.route.query;
      this.router.replace({query: {...restQuery}});
    },
    clearFieldError(fields: string[]) {
      fields.forEach((field) => {
        this.errors[field] = false; // Убираем ошибку для каждого указанного поля
      });
    },
    validateEmail(email: string): boolean {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
    validateSignInForm() {
      this.errors.username = !this.loginFormState.form.username;
      this.errors.password = !this.loginFormState.form.password;

      return !this.errors.username && !this.errors.password;
    },
    validateSignUpForm() {
      this.errors.name = !this.loginFormState.form.name;
      this.errors.surname = !this.loginFormState.form.surname;

      this.errors.username = !this.loginFormState.form.username;
      this.errors.invalidEmail = this.loginFormState.form.username != null && !this.validateEmail(this.loginFormState.form.username);

      // Проверка пароля на все условия
      const isPasswordValid =
          this.loginFormState.form.password &&
          this.loginFormState.form.password.length >= 8 && // Длина
          /\d/.test(this.loginFormState.form.password) && // Цифры
          /[A-Z]/.test(this.loginFormState.form.password); // Заглавные буквы

      this.errors.password = !isPasswordValid;

      this.errors.confirmPassword = !this.loginFormState.form.confirmPassword;

      this.errors.differentPasswords = !!(this.loginFormState.form.confirmPassword
          && this.loginFormState.form.confirmPassword != this.loginFormState.form.password);

      return !this.errors.name
          && !this.errors.surname
          && !this.errors.username
          && !this.errors.invalidEmail
          && !this.errors.password
          && !this.errors.confirmPassword
          && !this.errors.differentPasswords;
    },
    validateInitResetPasswordForm() {
      this.errors.username = !this.loginFormState.form.username;
      this.errors.invalidEmail = this.loginFormState.form.username != null && !this.validateEmail(this.loginFormState.form.username);

      return !this.errors.username
          && !this.errors.invalidEmail;
    },
    validateSetNewPasswordForm() {
      const isPasswordValid =
          this.loginFormState.newPasswordForm.password &&
          this.loginFormState.newPasswordForm.password.length >= 8 && // Длина
          /\d/.test(this.loginFormState.newPasswordForm.password) && // Цифры
          /[A-Z]/.test(this.loginFormState.newPasswordForm.password); // Заглавные буквы

      this.errors.password = !isPasswordValid;

      this.errors.confirmPassword = !this.loginFormState.newPasswordForm.confirmPassword;

      this.errors.differentPasswords = !!(this.loginFormState.newPasswordForm.confirmPassword
          && this.loginFormState.newPasswordForm.confirmPassword != this.loginFormState.newPasswordForm.password);

      return !this.errors.password
          && !this.errors.confirmPassword
          && !this.errors.differentPasswords;
    },
    validateRegByVk() {
      console.log("validateRegByVk")
      this.errors.agreeTerms = !this.loginFormState.form.agreeTerms;

      if (this.errors.agreeTerms) {
        this.loginFormState.errorMessage = "Необходимо принять условия соглашения"
      }
      return !this.errors.agreeTerms;
    },

    async handleAuthByVk() {
      await this.authByVk(this.closeLogin);
    },

    async handleRegByVk() {
      if (!this.validateRegByVk()) {
        return;
      }
      await this.authByVk(this.closeLogin);
    },

    async handleSignIn() {
      if (!this.validateSignInForm()) {
        return;
      }

      await grecaptcha.ready(async () => {
        this.captchaToken = await grecaptcha.execute(this.gRecaptchaKey, {
          action: "login",
        });

        await this.signIn(this.captchaToken);
      });
    },

    async handleSignUp() {
      if (!this.validateSignUpForm()) {
        return;
      }

      await grecaptcha.ready(async () => {
        this.captchaToken = await grecaptcha.execute(this.gRecaptchaKey, {
          action: "reg",
        });

        await this.signUp(this.captchaToken);
      });
    },

    async handleInitResetPassword() {
      if (!this.validateInitResetPasswordForm()) {
        return;
      }

      await grecaptcha.ready(async () => {
        this.captchaToken = await grecaptcha.execute(this.gRecaptchaKey, {
          action: "initResetPassword",
        });

        await this.initResetPassword(this.captchaToken, () => {
          this.changeTab("waitpassres")
        });
      });
    },

    async handleSetNewPassword() {
      if (!this.validateSetNewPasswordForm()) {
        return;
      }

      await grecaptcha.ready(async () => {
        this.captchaToken = await grecaptcha.execute(this.gRecaptchaKey, {
          action: "setNewPassword",
        });

        await this.setNewPassword(this.captchaToken, () => {
          this.changeTab("login")
        });
      });
    },

    changeTab(tabName: string) {
      this.loginFormState.errorMessage = ""

      // Сбрасываем все ошибки
      Object.keys(this.errors).forEach((key) => {
        this.errors[key] = false;
      });

      this.router.push({
        query: {
          ...this.route.query,
          slm: this.isVisible + "",
          tab: tabName
        }
      });
    },
  }
})
</script>

<style scoped>
.trip-record {
  border-radius: 0.25rem;
  padding: 20px;
  background: rgba(204, 204, 204, 0.1);
  margin-bottom: 2rem;
}

input,
textarea {
  border: 0px;
  border-radius: 5px;
  padding: 10px;
  background: rgba(204, 204, 204, 0.1);
  color: #18d26e;
}

input:focus,
textarea:focus {
  color: #18d26e;
  background-color: rgba(204, 204, 204, 0.1);
  outline: none;
}

.form-group {
  margin-bottom: 20px;
}

/* Удаляем тень вокруг кнопок при фокусе */
.btn:focus, .btn:active {
  outline: none;
  box-shadow: none;
}

/* Стили для активной кнопки */
.btn-primary {
  background-color: #0d6efd;
  border-color: #0d6efd;
  color: #fff;
}

.form-check {
  font-size: 0.95rem;
  line-height: 1.4;
  display: flex;
}

.form-check-input {
  margin-right: 10px;
  cursor: pointer;
}

.form-check-label a {
  color: #18d26e;
  font-weight: bold;
}

.form-check-label a:hover {
  color: #0d6efd;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 1000;
  display: flex;
}

.modal-content {
  overflow-y: auto; /* Включаем скроллинг по вертикали */
  background: black;
}

.close-btn {
  color: white;
  position: absolute;
  top: 10px;
  right: 10px;
  background: transparent;
  border: none;
  font-size: 30px;
  cursor: pointer;
}

.login-form {
  padding: 30px;
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
}

.error-container {
  position: relative;
  font-size: 1rem;
  background-color: #4b0000; /* Темный красный фон */
  color: #ff6666; /* Красный текст */
  border: 1px solid #ff6666; /* Красная рамка */
  padding: 10px 35px 10px 10px; /* Добавляем отступ справа для крестика */
  border-radius: 5px;
  margin-bottom: 20px;
  display: flex;
  align-items: center; /* Центрируем содержимое по вертикали */
}

.error-message i {
  margin-right: 8px;
  font-size: 18px; /* Немного больше значок */
}

.error-container__close {
  position: absolute;
  top: 20px; /* Смещаем крестик на 50% от верхнего края контейнера */
  right: 15px; /* Отступ от правого края */
  transform: translateY(-50%); /* Центруем крестик по вертикали относительно первой строки */
  background: transparent;
  border: none;
  color: #ff6666;
  font-size: 1.5rem;
  cursor: pointer;
}

.error-container__close:hover {
  color: #ff9999; /* Эффект наведения для улучшения UX */
}

.input-error {
  border-color: #ff4d4d;
  background-color: rgba(255, 0, 0, 0.1);
}

.form-control.input-error {
  border: 1px solid #ff6666; /* Красная рамка для выделения ошибки */
  background-color: rgba(255, 102, 102, 0.1); /* Светло-красный фон */
  color: #ff6666; /* Красный текст */
}

.form-control.input-error::placeholder {
  color: #ff6666; /* Красный текст для плейсхолдера */
  opacity: 1; /* Чтобы placeholder был четким */
}

.form-group__error-message {
  font-size: 0.875rem;
  color: #ff6666; /* Красный текст ошибки */
  margin-top: 5px;
}

</style>
